import LegalPage from './LegalPage';

// Mirrors the LAUNCHED flag in LandingPage.jsx — flip to true at iOS launch.
const LAUNCHED = false;

export default function Terms() {
  const file = LAUNCHED ? '/legal/terms-launched.md' : '/legal/terms-prelaunch.md';
  return <LegalPage file={file} title="Terms of Service" />;
}
